<script setup>
import { defineProps, computed, ref} from "vue";
import LinhaDeRecebimentosDeContasAReceber from "./LinhaDeRecebimentosDeContasAReceber.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "contaAReceber",
]);

//==================================================================//
//============ Recebimentos de Contas a Receber Headers ============//
//==================================================================//

let recebimentosHeaders = [
    { text: 'Seq do Recebimento',              value: 'sequencia'},
    { text: 'Tipo',                            value: 'tipo'},
    { text: 'Status',                          value: 'status'},
    { text: 'Job Parcela - Sequencia - Tipo',  value: 'jobParcela'},
    { text: 'Job Parcela - Descrição',         value: 'jobParcelaTipoDescricao'},
    { text: 'Conta Financeira',                value: 'contaFinanceira'},
    { text: 'Adiantamento - Sequencia',        value: 'contaAReceberAvulsaVinculada'},
    { text: 'Data Criação',                    value: 'dataCriacao'},
    { text: 'Data Vencimento',                 value: 'dataVencimento'},
    { text: 'Valor Liquidado',                 value: 'valorRecebimento'},
    { text: '',                                value: 'espaco'},
]

//==================================================================//
//======================= Mostra Recebimentos ========================//
//==================================================================//

let mostraRecebimentos = computed(()=>{

    if(props?.contaAReceber?.recebimentosQuantidade <= 0){
        return false;
    }

    if(props?.parcela?.aberto == false){
        return false;
    }

    return true;

});

</script>

<template>

    <div
        class="c-table__row-table"
        v-show="mostraRecebimentos"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <div class="c-table-wrapper">

                    <div class="c-table">

                        <div class="c-table__headers">

                            <div class="c-table__header" v-for="recebimentoHeader in recebimentosHeaders"
                                :key="recebimentoHeader.value"
                            >

                                <div class="c-table__header-content">

                                    {{recebimentoHeader.text}}

                                </div>
                                
                            </div>

                        </div>
                        <div class="c-table__body">

                            <LinhaDeRecebimentosDeContasAReceber v-for="recebimento in props?.contaAReceber?.recebimentos"
                                :key="recebimento.id"
                                :dado="props?.dado"
                                :contaAReceber="props?.contaAReceber"
                                :recebimento="recebimento"
                            ></LinhaDeRecebimentosDeContasAReceber>

                        </div>

                    </div>

                </div>
                
            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row-table{
    display: contents;
}

.c-table__row-table:hover > .c-table__cell{
    background-color: #eeeeee;
}

.c-table__cell{
    display: grid;
    grid-column: 1 / -1;
    font-size: 0.875rem;
}

.c-table-wrapper{
    overflow: hidden !important;
    padding: 12px 12px 12px 12px !important;
}

.c-table{
    background: #ffffff;
    display: grid;
    grid-template-columns: max-content max-content max-content max-content max-content max-content max-content max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

.c-table__headers{
    display: contents;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-table__header{
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #dedede;
    color: #363636;
}

.c-table__body{
    display: contents;
}

</style>
